import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function EnquireIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M15 4.92968H7V6.92968H15V4.92968ZM12 8.92968H7V10.9297H12V8.92968Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 3H5C4.44873 3 4 3.44824 4 4V18C4 18.5518 4.44873 19 5 19H7V21H5C3.3457 21 2 19.6543 2 18V4C2 2.3457 3.3457 1 5 1H17C18.6543 1 20 2.3457 20 4V7H18V4C18 3.44824 17.5513 3 17 3Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M9 23H13.9424L20.95 15.39C22.3543 13.9857 22.3548 11.7043 20.95 10.3C19.5457 8.8957 17.3243 8.8957 15.92 10.3L9 17.6084V23ZM11 18.83L17.32 11.71C17.9445 11.087 18.9655 11.085 19.59 11.71C20.215 12.335 20.2145 13.355 19.59 13.98L13.0244 21H11V18.83Z",
    fill: "currentColor"
  }));
}